import { VContainer, VRow, VCol, VSelect, VTextField, VBtn } from "vuetify/lib";

const FlowNodeStatus = [
  {
    label: "所有",
    value: -1,
  },
  {
    label: "进行中",
    value: 0,
  },
  {
    label: "完成/通过",
    value: 1,
  },
];

export default {
  props: {
    value: {
      type: Object,
      default: () => ({
        search: "",
        flow_node_id: null,
        user_flow_node_status: -1,
      }),
    },
  },
  data() {
    this.$set(this.value, "search", "");
    this.$set(this.value, "flow_node_id", "");
    this.$set(this.value, "user_flow_node_status", -1);
    return {
      flow_nodes: [
        {
          id: "",
          name: "所有节点",
        },
      ],
    };
  },
  computed: {},
  mounted() {
    this.onSearch();
    this.getFlowInfo();
  },
  methods: {
    onSearch() {
      this.$emit("search");
    },
    getFlowInfo() {
      Util.ajax
        .get(Util.api.get_flow_by_link_model, {
          params: {
            link_model: "SellOrder",
          },
        })
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          if (res.code === 1) {
            const data = res.data;
            data.nodes.forEach((node) => {
              this.flow_nodes.push(node);
            });
          } else {
            this.$Modal.error({
              title: "错误",
              content: res.msg,
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  render() {
    return (
      <div>
        <VContainer fluid>
          <VRow align="center">
            <VCol>
              <VBtn
                color="primary"
                elevation="2"
                style="margin-left: 20px;"
                onClick={() => {
                  this.$emit("add");
                }}
              >
                创建销售订单
              </VBtn>
            </VCol>
            <VCol>
              <VBtn
                type="warning"
                elevation="2"
                style="margin-left: 20px;"
                onClick={() => {
                  this.$emit("downloadTemplate");
                }}
              >
                下载导入模板
              </VBtn>
            </VCol>
            <VCol cols="3">
              <VSelect
                items={this.flow_nodes}
                label="流程节点"
                v-model={this.value.flow_node_id}
                item-text="name"
                item-value="id"
              ></VSelect>
            </VCol>
            <VCol>
              <VSelect
                items={FlowNodeStatus}
                label="流程状态"
                v-model={this.value.user_flow_node_status}
                item-text="label"
                item-value="value"
              ></VSelect>
            </VCol>
            <VCol cols="3">
              <VTextField label="搜索关键词" v-model={this.value.search} />
            </VCol>
            <VCol style="display: flex; align-items: center;">
              <VBtn
                color="primary"
                elevation="2"
                onClick={() => {
                  this.onSearch();
                }}
              >
                搜索
              </VBtn>
            </VCol>
          </VRow>
        </VContainer>
      </div>
    );
  },
};
